<ng-container *ngIf="theme === 'red'; else blueTheme">
  <div 
    class="bn-alert-notice bn-imp-notice manage-ap-imp-notice text-left mb-4 mt-0" 
    *ngIf="((policy && billedNoticeForUnenroll) || !policy) && !hideAlert"
  >
    <div class="bn-icon">
      <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
    </div>
    <div class="bn-content">
      <div class="bn-content-text">
        <div class="imp-notice-sec">
          <div class="imp-notice-info-block mr-3">
            <div class="imp-notice-title">Important notice</div>
              <ng-container *ngIf="!policy; else unEnrollNotice">
                <div class="manage-ap-imp-info" [innerHTML]="safeText"></div>
                <div class="manage-ap-imp-info" *ngIf="impText2">{{ impText2 }}</div>
              </ng-container>
              <ng-template #unEnrollNotice>
                <div class="manage-ap-imp-info" [innerHTML]="unenrollImpTextSafeText"></div>
              </ng-template>
          </div>

          <div class="imp-content-close">
            <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                (click)="onClose()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #blueTheme>
  <div class="bn-alert-notice bn-info-notice mb-4 mt-0" *ngIf="!hideAlert">
    <div class="bn-icon">
        <img src="./assets/img/images/bn-icon-info.svg" alt="info icon" />
    </div>
    <div class="bn-content">
      <div class="bn-content-text">
        <div class="imp-notice-sec">
          <div class="imp-notice-info-block mr-3">
            <div class="imp-notice-title">Important notice</div>
            <div class="manage-ap-imp-info" [innerHTML]="safeText">
              <ng-container *ngIf="linkText?.length && linkUrl?.length">
                <a class="underline"
                [routerLink]="[linkUrl]"><span>{{linkText}}</span></a>
              </ng-container>
            </div>
          </div>

          <div class="imp-content-close">
            <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                (click)="onClose()" />
          </div>
        </div>
      </div>
    </div>
  </div> 
</ng-template>
